import { Routes } from '@angular/router';
import { IntroductionComponent } from './lib/components';

export const IntroductionRouting: Routes = [
  {
    path: '',
    component: IntroductionComponent
  }
];
